import React, { useState } from 'react';
import ButtonCustomerOrders from './ButtonCustomerOrders';
import { TbChecklist, TbLogout, TbMapSearch, TbUserCircle } from 'react-icons/tb';
import { useLoginContext } from '../../Contexts/LoginContext';
import MainMenuItem from './MainMenuItem';
import Img from './Img';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useCartHook } from '../../Hooks/CartHook';
import Modal from './Modal';
import Confirm from './Confirm';
import Button from '../Form/Button';
import { HiXMark } from 'react-icons/hi2';
import ButtonLoginSSO from './ButtonLoginSSO';
import BoxContentTranslate from './BoxContentTranslate';
import { useTranslation } from 'react-i18next';

const MainMenu = () => {

    const { t } = useTranslation();
    const { isAuthenticated, user } = useLoginContext();
    const { setShowMainMenu } = useLayoutContext();
    const { isStoreCounter } = useOrderTypeContext();
    const navigate = useNavigate();
    const { getLinkToHome } = useStoreHook();
    const { removeLogin } = useCartHook();
    const [ showConfirmLogout, setShowConfirmLogout] = useState<boolean>(false);

    const handleClickProfile = () => {
        navigate('/perfil');
        setShowMainMenu(false);
    }

    const handleClickStores = () => {
        navigate('/lojas');
        setShowMainMenu(false);
    }

    const handleClickOrders = () => {
        navigate('/perfil/meus-pedidos')
        setShowMainMenu(false);
    }

    const handleLogout = () => {
        setShowConfirmLogout(false);
        removeLogin(false);
        setShowMainMenu(false);
        navigate(getLinkToHome());
    }

    return (
        <>
            <div className='flex flex-col justify-between h-full'>

                <section className='flex flex-col divide-y divide-gray-200 h-full p-4 pt-2 '>

                    <MainMenuItem
                        show={Boolean(!isStoreCounter)}
                        onClick={handleClickProfile}
                        disabled={!isAuthenticated}
                        icon={<TbUserCircle size={23} className='zoomInIconNoDelay' />}
                        text={user?.first_name || t('menu.main.profile.label')}
                        description={t('menu.main.profile.description')}
                    />

                    <MainMenuItem
                        show={!isStoreCounter}
                        onClick={handleClickStores}
                        icon={<TbMapSearch size={23} className='zoomInIconNoDelay' />}
                        text={t('menu.main.stores.label')}
                        description={t('menu.main.stores.description')}
                    />

                    <MainMenuItem
                        show={!isStoreCounter}
                        onClick={handleClickOrders}
                        icon={<TbChecklist size={25} className='zoomInIconNoDelay' />}
                        text={t('menu.main.orders.label')}
                        disabled={!isAuthenticated}
                    />

                    <ButtonCustomerOrders className={!isAuthenticated ? 'pointer-events-none' : ''}>
                        <MainMenuItem
                            icon={<TbChecklist size={25} className='zoomInIconNoDelay' />}
                            text={t('menu.main.orders.label')}
                            description={t('menu.main.orders.description')}
                            disabled={!isAuthenticated}
                        />
                    </ButtonCustomerOrders>

                    {/* <MainMenuItem
                        icon={<TbBell size={25} className='zoomInIconNoDelay' />}
                        text={t('menu.main.alerts.label')}
                        description={t('menu.main.alerts.description')}
                        disabled
                    /> */}

                    {Boolean(!isAuthenticated) &&
                        <ButtonLoginSSO asLink hasLinkIcon iconSize={25} className='flex gap-4 items-center p-2 py-5 cursor-pointer text-base font-semibold leading-none' />
                    }

                    <MainMenuItem
                        show={Boolean(isAuthenticated)}
                        onClick={() => setShowConfirmLogout(true)}
                        icon={<TbLogout size={23} className='zoomInIconNoDelay' />}
                        text={t('login.label_button_logout')}
                    />

                    <BoxContentTranslate onBottom />

                    {/* <Button onClick={() => setShowLoginBasic(true)}>BasicLogin</Button> */}

                    {/* <MainMenuItem
                        icon={<div className='zoomInIconNoDelay'><TbTicket size={25} className='-rotate-45' /></div>}
                        text={'Cupons'}
                        description={'Meus cupons de desconto'}
                        disabled
                    /> */}
                </section>
                <section className='flex items-center justify-between grayscale p-4 w-full'>
                    
                    <span className='w-24 text-gray-300 text-xs'>V {process.env.REACT_APP_VERSION}</span>
                    
                    <div className='flex gap-2 justify-center w-full'>
                        <Img src='/ditti-tagme.png' alt="Ditti by Tagme" className='max-h-12 inline opacity-75' />
                    </div>
                    
                    <div className='flex justify-end w-24'>
                        <Button rounded onClick={() => setShowMainMenu(false)}>
                            <div><HiXMark size={20} /></div>
                        </Button>
                    </div>
                </section>
            </div>

            <Modal open={showConfirmLogout} className="max-w-sm m-4" onClose={() => setShowConfirmLogout(false)}>
                <Confirm
                    title={t('login.confirm_logout_title')}
                    labelConfirm={t('login.confirm_logout_label_button')}
                    onConfirm={handleLogout}
                    onCancel={() => setShowConfirmLogout(false)}
                />
            </Modal>
        </>
    )
}

export default MainMenu;